import React from 'react';

import { ConfluenceIcon, ConfluenceLogo } from '@atlaskit/logo';

import LogoTable from '../utils/logo-table';

export default (): React.JSX.Element => (
	<LogoTable
		logo={<ConfluenceLogo appearance="brand" />}
		icon={<ConfluenceIcon appearance="brand" />}
	/>
);
